interface UploadButtonProps {
  onClick: () => void;
}

export default function UploadButton({ onClick }: UploadButtonProps) {
  return (
    <>
      {/* Desktop: inline button */}
      <button
        onClick={onClick}
        className="hidden sm:inline-flex btn-primary px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base hover:scale-105 active:scale-100"
      >
        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        <span className="text-sm sm:text-base">Upload</span>
      </button>

      {/* Mobile: floating action button (bottom left) */}
      <button
        onClick={onClick}
        className="sm:hidden fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full shadow-2xl flex items-center justify-center bg-gradient-to-r from-rose-500 via-fuchsia-500 to-indigo-500 text-white hover:scale-110 active:scale-95 transition-transform"
        aria-label="Upload photo"
      >
        <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
        </svg>
      </button>
    </>
  );
}

